import { formatCellValue } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import { Badge } from "@/components/ui/badge";
import type { PrivateHireIncludedItem } from "@/lib/coach-manager/types";

export function PrivateHireIncludedItemsTable({ items }: { items: PrivateHireIncludedItem[] }) {
  if (items.length === 0) return null;

  return (
    <DataTable headers={[{ label: "Item" }, { label: "Included" }, { label: "Excluded" }]}>
      {items.map((item) => (
        <tr key={`${item.PrivateHireMovementID}-${item.Item}`} className="border-b last:border-b-0">
          <td className="px-4 py-2">{formatCellValue(item.Item)}</td>
          <td className="px-4 py-2">
            {item.Included && <Badge variant="success">Included</Badge>}
          </td>
          <td className="px-4 py-2">
            {item.Excluded && <Badge variant="destructive">Excluded</Badge>}
          </td>
        </tr>
      ))}
    </DataTable>
  );
}
